<script>
import { mapActions, mapState } from 'vuex';
import LogoHeader from '../components/onboarding/logo-header.vue';

export default {
  name: 'ScheduleEvent',
  components: {
    LogoHeader,
  },
  data() {
    return {
      email: '',
      error: '',
    };
  },
  computed: {
    ...mapState({
      formLoading: (state) => state.vyteEvent.formLoading,
      userLoading: (state) => state.vyteEvent.userLoading,
      user: (state) => state.vyteEvent.user,
    }),
  },

  created() {
    const {
      params: { id: eventId },
      query: { token },
    } = this.$route;

    if (!eventId || !token) return;

    this.getUser({ eventId, token });
  },
  methods: {
    ...mapActions(['getUser', 'submitForm']),
    async handleContinue() {
      this.error = '';

      const {
        params: { id: eventId },
      } = this.$route;

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.email) || !this.email) {
        this.error = 'Please enter a valid email address.';
        return;
      }

      if (!this.user || !this.user.userId || !eventId) {
        this.error = 'User data is not available.';
        return;
      }

      const response = await this.submitForm({
        eventId,
        userId: this.user.userId,
        email: this.email,
      });
      if (!response || !response.ok) {
        this.error = response.message;
      }
    },
  },
};
</script>

<template>
  <div class="main-container">
    <div class="container pt-5">
      <div v-if="userLoading" class="my-5 text-center">
        <b-spinner variant="primary" style="width: 4rem; height: 4rem" />
      </div>
      <div v-else>
        <div class="mx-auto w-75 bg-light p-3 text-center">
          <div v-if="!userLoading && user && user.userId">
            <div class="logo-container">
              <logo-header />
            </div>
            <h4 class="text-muted mb-5">
              Hey {{ user.name || ' ' }} 👋, we don't have your email on file, could you please
              enter your email so we can include you in the calendar invitation.
            </h4>
            <b-form-input
              v-model="email"
              size="lg"
              placeholder="awesome@email.com"
              class="mb-4"
              autocomplete="off"
              required
            ></b-form-input>

            <div v-if="error" class="text-danger mb-3">
              {{ error }}
            </div>
            <b-button
              block
              variant="primary"
              size="lg"
              @click="handleContinue"
              :disabled="formLoading"
              >Continue</b-button
            >
          </div>
          <div v-else>
            <h2>
              Sorry, something went wrong. Refresh and try again. If the problem continues, please
              contact support
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-container {
  height: 100vh;
  background-color: #f8f9fa !important;
}

.logo-container {
  justify-items: center;
  margin-bottom: 20px;
}
</style>
